import React, { useState, useEffect } from "react";
import './ActivateAccount.css';
import '../Login/Login.css';
import { Globals } from "../../global/Globals";
import Button from "../../components/Button/Button";
import Footer from "../../components/Footer/Footer";
import { validatePassword } from '../../util/util';
import { getRecordsFromActivationLink, activateAccount } from '../../services/AccountActivationAPI';
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import PopUp from "../../components/PopUp/PopUp";

const ActivateAccount = () => {
    const navigate = useNavigate();
    const { activationToken } = useParams();
    const [password, setPassword] = useState('');
    const [reEnteredPassword, setReEnteredPassword] = useState('');
    const [isPasswordEmpty, setPasswordEmpty] = useState('');
    const [isReEnteredPasswordEmpty, setReEnteredPasswordEmpty] = useState('');
    const [isPasswordInValid, setPasswordInValid] = useState(false);
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [isReEnteredPasswordInValid, setReEnteredPasswordInValid] = useState(false);
    const [isReEnteredPasswordVisible, setReEnteredPasswordVisible] = useState(false);
    const [isPasswordNotMatched, setIsPasswordNotMatched] = useState(false);
    const [isDataAvailable, setIsDataAvailable] = useState(true);
    const [isCompany, setIsCompany] = useState(false);
    const [producerId, setProducerId] = useState('');
    const [producerRecords, setProducerRecords] = useState({ name: '', email: '' });
    const [companyRecords, setCompanyRecords] = useState({ companyName: '', keyContactName: '', keyContactEmail: '' });
    const [isActivationScuccess, setActivationSuccess] = useState(false);
    const [isActivationFailure, setActivationFailure] = useState(false);
    const [isPasswordFieldMisMatch, setPasswordFieldMisMatch]=useState(false);
    const handlePassword = (e) => {
        setPasswordEmpty(false);
        setPasswordInValid(false);
        setPassword(e.target.value);
        setIsPasswordNotMatched(false);
        setPasswordFieldMisMatch(false);
    }

    useEffect(() => {
        try {
            getRecordsFromActivationLink(activationToken.replace(/:/, "")).then((resp) => {
                setIsDataAvailable(true);
                const data = resp.data.content;
                setProducerId(data[0]?.producerId);
                if (data[0].producerType === "Individual") {
                    setIsCompany(false);
                    setProducerRecords({ name: data[0]?.name, email: data[0]?.email })
                }
                else {
                    setIsCompany(true);
                    setCompanyRecords({ companyName: data[0]?.companyName, keyContactName: data[0]?.name, keyContactEmail: data[0]?.email })
                }
            })
                .catch((error) => {
                    setIsDataAvailable(false);
                    console.error("Error in getting records from Activation link : ", error);
                })
        }
        catch (error) {
            setIsDataAvailable(false);
        }
    }, [!isDataAvailable])

    const handleReEneteredPassword = (e) => {
        //setPasswordValid(true);
        setReEnteredPasswordEmpty(false);
        setReEnteredPasswordInValid(false);
        setIsPasswordNotMatched(false);
        setReEnteredPassword(e.target.value);
    }
    const tooglePasswordView = (id, mode) => {
        const passwordInput = document.getElementById(id);
        const passwordType = passwordInput.getAttribute('type');
        if (passwordType === 'password') {
            passwordInput.setAttribute('type', 'text');
            mode === "password" ? setPasswordVisible(true) : setReEnteredPasswordVisible(true);
        }
        else {
            passwordInput.setAttribute('type', 'password');
            mode === 'password' ? setPasswordVisible(false) : setReEnteredPasswordVisible(false);
        }
    }

    const checkForPassword = (fieldName) => {
        if (fieldName === 'password') {
            setPasswordEmpty(false);
            setPasswordInValid(false);
            setPasswordFieldMisMatch(false);
            if (password.length > 0) {
                const isValid = validatePassword(password);
                isValid ? setPasswordInValid(false) : setPasswordInValid(true);
                if ((password.length>0 && reEnteredPassword.length>0)&&(password !== reEnteredPassword)) {
                    setPasswordFieldMisMatch(true);
                    setIsPasswordNotMatched(false);
                }
            }
            else {
                setPasswordEmpty(true);
            }
        }
        else {
            setReEnteredPasswordInValid(false);
            setReEnteredPasswordEmpty(false);
            setIsPasswordNotMatched(false);
            if (reEnteredPassword.length > 0) {
                if (password !== reEnteredPassword) {
                    setIsPasswordNotMatched(true);
                    setPasswordFieldMisMatch(false);
                }
                else {
                    setIsPasswordNotMatched(false);
                    const isValid = validatePassword(reEnteredPassword);
                    isValid ? setReEnteredPasswordInValid(false) : setReEnteredPasswordInValid(true);
                }
            }
            else {
                setReEnteredPasswordEmpty(true);
            }
        }
    }
    const submitDetails = () => {
        password === reEnteredPassword? setIsPasswordNotMatched(false):setIsPasswordNotMatched(true);
        if (!isPasswordFieldMisMatch && !isPasswordNotMatched && !isPasswordEmpty && !isPasswordInValid && !isReEnteredPasswordEmpty && !isReEnteredPasswordInValid) {
            activateAccount(producerId, password.toString()).then((response) => {
                if (response?.data === "Account activated successfully") {
                    setActivationSuccess(true);
                }
                else {
                    setActivationFailure(true);
                }

            }).catch((error) => {
                console.error("Error in Activation API ===> ", error);
                setActivationFailure(true);
            })
        }
    }

    const navigateToLogin = () => {
        navigate(Globals.NAVPATH.HOME)
    }
    return (
        <>
            {/* {!isDataAvailable && <Loader height={50} width={50} component={"Myproposals"} />} */}
            <div id="activation-page-layout" className="activation-page-layout">
                <div id="activation-page-container" className="activation-page-container">
                    <div id="activation-page-content-container" className="activation-page-content-container">
                        <div id="mc-company-logo-container" className="mc-company-logo-container">
                            <img id="mc-company-logo" className="mc-company-logo" src={Globals.IMG.CAROUSAL_LOGO} alt="logo" />
                        </div>
                        <div id="activation-account-title-container" className="activation-account-title-container">
                            <div className="activation-account-title-div" id="activation-account-title-div">
                                <h3 className="activation-account-title" id="activation-account-title">{Globals.ACTIVATE_ACCOUNT.PAGE_TITLE}</h3>
                            </div>
                        </div>

                        <div id="activation-account-user-details" className="activation-account-user-details">
                            <div id="test" className="test">
                                {isCompany && <div id="activation-account-company-details" className="activation-account-company-details">
                                    <div className="activation-account-company-label">
                                        <lable className="activation-content-text-label data-headings">{Globals.ACTIVATE_ACCOUNT.COMPANY_NAME_TITLE}</lable>
                                    </div>
                                    <div className="activation-account-company-name">
                                        <label className="activation-content-text-styles response-data">{companyRecords?.companyName}</label>
                                    </div>
                                </div>}
                                <div id="activation-account-key-contact-name-details" className="activation-account-key-contact-name-details">
                                    <div className="activation-account-key-contact-name-label">
                                        <label className="activation-content-text-label data-headings">{isCompany ? Globals.ACTIVATE_ACCOUNT.KEY_CONTACT_NAME_TITLE : Globals.ACTIVATE_ACCOUNT.PRODUCER_NAME}</label>
                                    </div>
                                    <div className="activation-account-key-contact-name">
                                        <label className="activation-content-text-styles response-data">{isCompany ? companyRecords.keyContactName : producerRecords.name}</label>
                                    </div>
                                </div>
                                <div id="activation-account-key-contact-email-details" className="activation-account-key-contact-email-details">
                                    <div className="activation-account-key-contact-email-label">
                                        <label className="activation-content-text-label data-headings">{isCompany ? Globals.ACTIVATE_ACCOUNT.KEY_CONTACT_EMAIL_TITLE : Globals.ACTIVATE_ACCOUNT.PRODUCER_EMAIL}</label>
                                    </div>
                                    <div className="activation-account-key-contact-email">
                                        <label className="activation-content-text-styles response-data">{isCompany ? companyRecords.keyContactEmail : producerRecords.email}</label>
                                    </div>
                                </div>

                                <div id="activation-account-password-details " className="activation-account-password-details activation-password">
                                    <label id="password-field-title" className="password-field-title">{Globals.ACTIVATE_ACCOUNT.PASSWORD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <div className="activation-account-password-label password_container" onBlur={() => checkForPassword('password')}>
                                        <span className={`password-inp-container ${(isPasswordInValid || isPasswordEmpty || isPasswordFieldMisMatch) ? 'error-field' : ''} ${(password.length > 0 && !isPasswordEmpty && !isPasswordInValid) ? 'valued-field' : ''}`}><input type="password" id="password-inp" className="password-inp password-text" name="password" placeholder={Globals.LOGIN.PASSWORD_PLACEHOLDER} onChange={handlePassword} required></input><img className="view-hide-password" src={!isPasswordVisible ? Globals.IMG.HIDE_PASSWORD : Globals.IMG.VIEW_PASSWORD} alt="view-hide" onClick={() => tooglePasswordView('password-inp', "password")} /></span>
                                    </div>
                                    {(isPasswordInValid || isPasswordEmpty || isPasswordFieldMisMatch) && <><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{((isPasswordFieldMisMatch && Globals.ERROR_MESSAGES.ACTIVATION_PAGE_PASSWORD_MISMATCH) )||(isPasswordNotMatched && Globals.ERROR_MESSAGES.ACTIVATION_PAGE_PASSWORD_MISMATCH) ||(isPasswordEmpty ? Globals.ERROR_MESSAGES.ACTIVATE_PASSWORD_EMPTY : Globals.ERROR_MESSAGES.ACTIVATION_PAGE_PASSWORD_ERROR)}</label></>}
                                </div>
                                <div id="activation-account-re-enter-password-details" className="activation-account-re-enter-password-details activation-password">
                                    <label id="password-field-title" className="password-field-title">{Globals.ACTIVATE_ACCOUNT.RE_TRY_PASSWORD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <div className="activation-account-re-enter-password-label password_container" onBlur={() => checkForPassword('re-enter')}>
                                        <span className={`password-inp-container ${(isReEnteredPasswordInValid || isReEnteredPasswordEmpty || isPasswordNotMatched) ? 'error-field' : ''} ${reEnteredPassword.length > 0 && !isReEnteredPasswordEmpty && !isReEnteredPasswordEmpty && !isPasswordNotMatched ? 'valued-field' : ''}`}><input type="password" id="re-password-inp" className="password-inp re-password-inp password-text" name="password" placeholder={Globals.LOGIN.PASSWORD_PLACEHOLDER} onChange={handleReEneteredPassword} required></input><img className="view-hide-password" src={!isReEnteredPasswordVisible ? Globals.IMG.HIDE_PASSWORD : Globals.IMG.VIEW_PASSWORD} alt="view-hide" onClick={() => tooglePasswordView('re-password-inp', "re-enter")} /></span>
                                    </div>
                                    {(isReEnteredPasswordInValid || isReEnteredPasswordEmpty || isPasswordNotMatched) && <><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{(isPasswordNotMatched && Globals.ERROR_MESSAGES.ACTIVATION_PAGE_PASSWORD_MISMATCH) || (isReEnteredPasswordEmpty ? Globals.ERROR_MESSAGES.ACTIVATE_RE_ENTER_PASSWORD_EMPTY : Globals.ERROR_MESSAGES.ACTIVATION_PAGE_PASSWORD_ERROR)}</label></>}
                                </div>
                            </div>
                            <div id="activation-account-password-criteria-details" className="activation-account-password-criteria-details">
                                <div className="activation-account-password-criteria">
                                    <div id="activation-account-password-criteria-title" className="activation-account-password-criteria-title password-criteris-txt-color">
                                        <img src={Globals.IMG.PASSWORD_CRITERIA} alt="password criteria password-criteria-txt-color" />
                                        <p className="activation-content-text-label password-criteria-txt-color">{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.TITLE}</p>
                                    </div>
                                    <div className="activation-content-text-styles password-criteria-txt-color">
                                        <li>{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.CHARS_RANGE}</li>
                                        <li>{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.ATLEAST_1_UC}</li>
                                        <li>{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.ATLEAST_1_NUM}</li>
                                        <li>{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.ATLEAST_ONE_SPECIAL_CHARCTER}</li>
                                        <li>{Globals.ACTIVATE_ACCOUNT.PASSWORD_CRITERIA.NO_SPACE}</li>
                                    </div>
                                </div>
                            </div>
                            <div className="activation-account-button" id="activation-account-button">
                                {(password.length > 0 && reEnteredPassword.length > 0 && !isPasswordFieldMisMatch && !isPasswordNotMatched && !isPasswordEmpty && !isPasswordInValid && !isReEnteredPasswordEmpty && !isReEnteredPasswordInValid) ? <Button title={Globals.ACTIVATE_ACCOUNT.BUTTON_TITLE} action={submitDetails} additionalStyle={"activate-account-btn"} /> :
                                    <Button title={Globals.ACTIVATE_ACCOUNT.BUTTON_TITLE} additionalStyle={"disabled-activate-account-btn"} />}
                            </div>
                        </div>
                    </div>
                </div>
                { }
            </div>
            <div id="activation-page-footer" className="activation-page-footer">
                <Footer />
            </div>
            <div>
                {isActivationScuccess && <div className='popup-bg'><PopUp title={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.SUCCESS.TITLE}
                    text={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.SUCCESS.MESSAGE}
                    normalAction={navigateToLogin}
                    normalActionText={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.SUCCESS.BUTTON_TEXT}
                    popupType={"activate-success"}
                    onClose={() => setActivationSuccess(false)}
                /></div>}
                {isActivationFailure && <div className='popup-bg'><PopUp title={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.FAILURE.TITLE}
                    text={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.FAILURE.MESSAGE}
                    normalAction={submitDetails}
                    normalActionText={Globals.ACTIVATE_ACCOUNT.POPUP_MESSAGE.FAILURE.BUTTON_TEXT}
                    popupType={"activate-failure"}
                    onClose={() => setActivationFailure(false)}
                /></div>}
            </div>
        </>
    );
}
export default ActivateAccount;